import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components/src/FocusButton';
import { responsive, sp } from '@main/theme';

/**
 * Back wrapper
 */
export const BackWrapper = styled(FocusButton)`
  display: flex;
  padding: 2px 6px 2px 0;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

/**
 * Back Icon wrapper
 */
export const BackIconWrapper = styled.img`
  width: ${sp(2.5)};
`;

/**
 * The Icon wrapper
 */
export const IconWrapper = styled.img`
  width: ${sp(6.5)};
`;

/**
 * Confirm Banner Wrapper
 */
export const ConfirmBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${sp(2.2)};
`;

/**
 * Confirm Header wrapper
 */
export const ConfirmHeaderWrapper = styled.h3`
  font-size: ${sp(2.8)};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 0 ${sp(0.3)};
  line-height: ${sp(3.6)};
`;

/**
 * Confirm Description wrapper
 */
export const ConfirmDescriptionWrapper = styled.p`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: ${sp(2)};
  margin-bottom: ${sp(4)};
  line-height: ${sp(3.15)};

  ${responsive.atLeastTablet} {
    padding: 0 ${sp(10)};
  }

  ${responsive.atLeastDesktop} {
    padding: 0 ${sp(16)};
  }
  ${({ theme }) => theme.componentStyles.takeControlConfirmation}
`;

/**
 * The Confirm Modal Wrapper
 */
export const TakeControlConfirmWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${sp(5)};

  ${responsive.atLeastTablet} {
    padding: ${sp(5)} ${sp(10)};
  }
`;
